<template>
  <div
    class="boss-message-mail-subject"
    data-test="subject"
  >
    {{ subject | formatSubject }}
  </div>
</template>

<script>
export default {
  filters: {
    formatSubject (val) {
      return val ? `件名：${val}` : ''
    }
  },
  props: {
    subject: {
      type: String,
      default: ''
    }
  }
}
</script>
